import Vue from 'vue'
export default new Vue;// 脚本  类似于子类调用父类方法